import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import { getPricingUrl } from 'marketplace-ui-common/utils/urls';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import CompatibilityIcon from './CompatibilityIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureCompatibilityMessage = ({
  isCompatible,
  missingPlanApiName,
  missingPlanDisplayName,
  onCompatibilityModalOpen,
  onTrackInteraction = () => {}
}) => {
  const {
    appContext
  } = useDetailsPageContext();
  const isPublic = appContext === 'public';
  if (isPublic) {
    return null;
  }
  if (isCompatible) {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      gap: "200",
      children: [/*#__PURE__*/_jsx(CompatibilityIcon, {
        compatibilityType: "COMPATIBLE_ALL"
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "detailsPage.compatibility.features.compatible_jsx",
          elements: {
            Bold: 'b'
          }
        })
      })]
    });
  } else if (missingPlanDisplayName) {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      gap: "200",
      children: [/*#__PURE__*/_jsx(CompatibilityIcon, {
        compatibilityType: "COMPATIBLE_NONE"
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "detailsPage.compatibility.features.missingPlan_jsx",
          elements: {
            Link
          },
          options: {
            linkProps: {
              external: true,
              href: getPricingUrl(isPublic, missingPlanApiName || '', getLang())
            },
            planName: missingPlanDisplayName
          }
        })
      })]
    });
  } else {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      gap: "200",
      children: [/*#__PURE__*/_jsx(CompatibilityIcon, {
        compatibilityType: "COMPATIBLE_NONE"
      }), /*#__PURE__*/_jsx(Text, {
        children: onCompatibilityModalOpen ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "detailsPage.compatibility.features.notCompatible_jsx",
          elements: {
            Link
          },
          options: {
            linkProps: {
              onClick: () => {
                onCompatibilityModalOpen === null || onCompatibilityModalOpen === void 0 || onCompatibilityModalOpen();
                onTrackInteraction === null || onTrackInteraction === void 0 || onTrackInteraction({
                  action: 'open plan combinations modal'
                });
              }
            }
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.compatibility.features.notCompatible"
        })
      })]
    });
  }
};